export const GET_LISTINGS_PENDING = 'getListingsPending';
export const GET_LISTINGS_FULFILLED = 'getListingsFulfilled';
export const GET_LISTINGS_REJECTED = 'getListingsRejected';

export const LISTINGS_PAGINATION_PENDING = 'ListingsPaginationPending';
export const LISTINGS_PAGINATION_FULFILLED = 'ListingsPaginationFulfilled';
export const LISTINGS_PAGINATION_REJECTED = 'ListingsPaginationRejected';
